module.exports = __webpack_public_path__ + "2ed2f2a2d52007085bf7fd773627e3e0.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/4_column_small_x1/public/team/Leadership_Greg.jpg
// module id = 419
// module chunks = 0